import {
  createRootRoute,
  createRoute,
  createRouter,
  Outlet,
  useNavigate,
} from '@tanstack/react-router'
import { lazy, useEffect } from 'react'
import { useAuth } from '@/features/auth/AuthProvider'
import LoginScreenComponent from '@/features/auth/LoginScreen'

const HomeScreen = lazy(() => import('@/features/folders/HomeScreen'))
const FolderScreen = lazy(() => import('@/features/folders/FolderScreen'))
const BoardScreen = lazy(() => import('@/features/boards/BoardScreen'))

const rootRoute = createRootRoute({
  component: () => <Outlet />,
})

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: LoginGate,
})

function LoginGate() {
  const { user, loading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!loading && user) {
      void navigate({ to: '/', replace: true })
    }
  }, [loading, user, navigate])

  if (loading || user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg">
        <div className="w-6 h-6 rounded-full border-2 border-fg-subtle/30 border-t-accent animate-k-spin" />
      </div>
    )
  }
  return <LoginScreenComponent />
}

const appRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: '_app',
  component: AppShell,
})

const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/',
  component: HomeScreen,
})

const folderRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/folders/$folderId',
  component: FolderScreen,
})

const boardRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/boards/$boardId',
  component: BoardScreen,
})

const routeTree = rootRoute.addChildren([
  loginRoute,
  appRoute.addChildren([indexRoute, folderRoute, boardRoute]),
])

export const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

function AppShell() {
  const { user, loading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!loading && !user) {
      void navigate({ to: '/login', replace: true })
    }
  }, [loading, user, navigate])

  if (loading || !user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg">
        <div className="w-6 h-6 rounded-full border-2 border-fg-subtle/30 border-t-accent animate-k-spin" />
      </div>
    )
  }
  return <Outlet />
}
